import { CanceledContractListPage } from "@/features/match/pages/CanceledContractList";
import React from "react";

const CanceledContractList = () => {
  return <CanceledContractListPage />;
};

export default CanceledContractList;
